import { render } from "./DocumentFieldConfigViewer.vue?vue&type=template&id=8a6101ea&ts=true"
import script from "./DocumentFieldConfigViewer.vue?vue&type=script&lang=ts"
export * from "./DocumentFieldConfigViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__